import { AfterViewInit, Component, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { ChartRendererService } from '../../../../my-shared-lib/src/lib/shared-services/chart-renderer.service';
import { Subscription } from 'rxjs';
import { ConfigService } from '../../../../my-shared-lib/src/lib/shared-services/config.service';


@Component({
  selector: 'app-widget-renderer',
  imports: [],
  standalone: true,
  templateUrl: './widget-renderer.component.html',
  styleUrl: './widget-renderer.component.scss'
})
export class WidgetRendererComponent implements AfterViewInit, OnDestroy {
  @Input() charts!: any
  @ViewChildren('chartContainer', { read: ViewContainerRef })
  chartContainers!: QueryList<ViewContainerRef>;
  subscription!: Subscription;

  @Output() editRecord = new EventEmitter<any>();
  @Output() recordSelected = new EventEmitter<any>();

  constructor(
    private chartRendererService: ChartRendererService,
    private configService: ConfigService
  ) { }

  ngAfterViewInit(): void {
    if (this.chartContainers.length > 0) {
      const container = this.chartContainers.first;
      const chart = this.charts;
      if (chart) {
        const componentRef = this.chartRendererService.renderChart(chart.type, container, chart);
        if (componentRef && componentRef.instance) {
          // Forward events from the dynamic component
          if (componentRef.instance.editRecord) {
            componentRef.instance.editRecord.subscribe((record: any) => {
              this.editRecord.emit(record);
            });
          }
          if (componentRef.instance.recordSelected) {
            componentRef.instance.recordSelected.subscribe((record: any) => {
              this.recordSelected.emit(record);
            });
          }
        }
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

